import { Root } from "@radix-ui/react-alert-dialog";

interface AlertRootProps {
  children: React.ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  isControlled: boolean;
}

const AlertRoot = ({
  children,
  onOpen,
  onClose,
  isControlled,
  onOpenChange = undefined,
  isOpen = undefined,
}: AlertRootProps) => {
  if (isControlled) {
    if (isOpen === undefined || onOpenChange === undefined) {
      // Throw an error if either isOpen or onOpenChange is not provided when expected
      throw new Error(
        "AlertRoot: 'isOpen' and 'onOpenChange' props must be provided when 'isControlled' is true.",
      );
    }
    return (
      <Root open={isOpen} onOpenChange={onOpenChange}>
        {children}
      </Root>
    );
  }

  const handleOpenChange = (open: boolean) => {
    if (open) {
      onOpen?.();
    } else {
      onClose?.();
    }
  };

  return <Root onOpenChange={handleOpenChange}>{children}</Root>;
};

export { AlertRoot };
